import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router/index.js";
import { installTikTokShareEntry } from "@/services/tiktokShare.js";
import "flag-icons/css/flag-icons.min.css";
import "./styles/base.css";
import "./styles/game.css";

window.__BRICKSBEATER_VUE__ = true;

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.mount("#app");

router.isReady().then(() => {
  installTikTokShareEntry(router);
});
